module.exports = __webpack_public_path__ + "static/media/aqua-area.69183754.jpg";